<template>
  <nav class="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
    <div class="w-full flex flex-wrap md:flex-nowrap	  items-center justify-between mx-auto p-3">
      <router-link to="/" class="mr-10">
        <img class="md:height-[100px] height-60px md:w-[100px] w-[60px]" src="compressed-logo.png" alt="Logo">
      </router-link>
      <div class="flex md:order-2  space-x-3 md:space-x-0 rtl:space-x-reverse">
        <div class="dropdown">
          <button id="" @click="profiledropdown"
            class="flex items-center dropbtn text-sm pe-1 font-medium text-emerald-500 rounded-full hover:text-emerald-500 dark:hover:text-blue-500 md:me-0    dark:text-white"
            type="button">
            <span class="sr-only">Open user menu</span>
            <img class="w-8 h-8 me-2  rounded-full" :src="image" alt="user photo">{{ display_name }}
            <svg class="w-11 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 10 6">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 4 4 4-4" />
            </svg>
          </button>
          <div id="" v-if="isProfile"
            class=" z-10 dropdown-content bg-gray-100 divide-y divide-gray-100  shadow w-44 dark:bg-gray-700">
            <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
              <li>
                <router-link to="/profile" @click="isProfile = false"
                  class="block px-4 py-2 hover:bg-gray-100 hover:text-emerald-500 dark:hover:bg-gray-600 dark:hover:text-white">Update
                  Profile</router-link>
              </li>
              <li>
                <router-link to="/password" @click="isProfile = false"
                  class="block px-4 py-2  hover:bg-gray-100 hover:text-emerald-500 dark:hover:bg-gray-600 dark:hover:text-white">Update
                  Password</router-link>
              </li>
              <li class="py-2">
                <a role="button" @click="handleLogout"
                  class="text-black  hover:text-emerald-500  focus:ring-blue-300 font-medium  text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700  dark:focus:ring-blue-800">Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="md:hidden flex items-center">
          <button aria-label="Hamburger Menu" class="flex items-center rounded"
            @click="showMobileMenu = !showMobileMenu">
            <span class="sr-only">Open main menu</span>
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M1 1h15M1 7h15M1 13h15" />
            </svg>
          </button>
        </div>
      </div>
      <div class="items-center justify-between  w-full md:flex  md:order-1" :class="[
            {
              hidden: !showMobileMenu
            }
          ]">
        <ul
          class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
          <li>
            <router-link v-if="hasDashboardPermission" to="/" @click="() => {
            showMobileMenu = !showMobileMenu

          }
            "
              class="block py-2  font-sans text-lg	 px-3 text-regal-blue border-b
                 border-gray-100 hover:text-emerald-500	 md:hover:bg-transparent md:border-0  md:p-0 dark:text-blue-500  dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent "
              aria-current="page"> Dashboard</router-link>
          </li>
          <div class="dropdown"
            v-if="hasViewusersetup || hasViewcitysetup || hasViewTehsilsetup || hasViewShiftsSetupPermission || hasViewHospital || hasEnterdailyroasterPermission || hasviewstaff || hasrolesetupview || canseesetupsops">
            <li class="dropbtn">
              <button id="mega-menu-icons-dropdown-button" data-dropdown-toggle="mega-menu-icons-dropdown"
                class="flex font-sans text-lg  items-center justify-between w-full py-2 px-3 font-medium  border-b border-gray-100 md:w-auto hover: text-regal-blue  md:border-0 hover:text-emerald-500	 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700">
                Setup
                <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 10 6">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 4 4 4-4" />
                </svg>
              </button>
            </li>
            <div class="dropdown-content ">
              <router-link v-if="hasViewusersetup" class="font-sans text-sm	hover:text-emerald-500"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/user">Users</router-link>
              <router-link v-if="hasrolesetupview" to="/role" @click="() => { showMobileMenu = !showMobileMenu }"
                class=" font-sans text-sm	hover:text-emerald-500">Roles</router-link>


              <router-link v-if="hasViewHospital" class=" font-sans text-sm	hover:text-emerald-500	"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/Hospital">Hospitals</router-link>


              <router-link v-if="hasEnterdailyroasterPermission" class=" font-sans text-sm	hover:text-emerald-500	"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/dailyroaster">Daily Roaster</router-link>

              <router-link v-if="canseesetupsops" class=" font-sans text-sm	hover:text-emerald-500	"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/sops">SOPs </router-link>

              <router-link v-if="hasviewstaff" class=" font-sans text-sm	hover:text-emerald-500	"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/Staff">Staff</router-link>
              <router-link v-if="hasViewShiftsSetupPermission" class="font-sans text-sm	hover:text-emerald-500	" @click="() => {
            showMobileMenu = !showMobileMenu
          }" to="/shift">Shifts</router-link>

              <router-link v-if="hasViewTehsilsetup" class="font-sans text-sm	hover:text-emerald-500	" @click="() => {
            showMobileMenu = !showMobileMenu
          }" to="/tehsil"> Tehsils/Location</router-link>
              <router-link v-if="hasViewcitysetup" class="font-sans text-sm	hover:text-emerald-500	" @click="() => {
            showMobileMenu = !showMobileMenu
          }" to="/city">Cities </router-link>
            </div>
          </div>
          <div class="dropdown" v-if="hasCollectionConsolePermission || hasViewDisposalConsolePermission">
            <li class="dropbtn">
              <button id="mega-menu-icons-dropdown-button" data-dropdown-toggle="mega-menu-icons-dropdown"
                class="flex items-center font-sans text-lg		justify-between w-full py-2 px-3 font-medium text-regal-blue border-b border-gray-100 md:w-auto hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-emerald-500	 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700">
                Transactions
                <svg class="w-2.5 h-2.h5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 10 6">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 4 4 4-4" />
                </svg>
              </button>
            </li>
            <div class="dropdown-content  ">
              <router-link v-if="hasCollectionConsolePermission" class="font-sans text-sm hover:text-emerald-500	"
                @click="() => {
            showMobileMenu = !showMobileMenu
          }" to="/collectionEntery">Collection
                Console</router-link>
              <router-link v-if="hasViewDisposalConsolePermission" class="font-sans text-sm	hover:text-emerald-500	"
                @click="() => {
            showMobileMenu = !showMobileMenu

          }
            " to="/incinerationConsole">Disposal
                Console</router-link>
            </div>
          </div>
          <div class="dropdown" v-if="cangenerateInfectiousWasteMonitoringReport || cangenerate24hoursreport || cangeneratedaterangereport || cangenerateweeklyreport || cangenerateMonthlyreport || cangenerateQuertelyreport || cangenerateQuerterYearlyreport ">
            <li class="dropbtn">
              <button id="mega-menu-icons-dropdown-button" data-dropdown-toggle="mega-menu-icons-dropdown"
                class="flex font-sans text-lg  items-center justify-between w-full py-2 px-3 font-medium  border-b border-gray-100 md:w-auto hover: text-regal-blue  md:border-0 hover:text-emerald-500	 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700">
                Report
                <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 10 6">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 4 4 4-4" />
                </svg>
              </button>
            </li>
            <div class="dropdown-content3 ">
              
              <router-link v-if="cangenerateInfectiousWasteMonitoringReport" class="font-sans text-sm	hover:text-emerald-500"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/InfectiousWasteMonitoringReport">Infectious Waste Monitoring Report</router-link>

              <router-link v-if="cangenerate24hoursreport" class="font-sans text-sm	hover:text-emerald-500"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/TweentyFourHoursReport">24 Hrs Progress
                Report</router-link>

              <router-link v-if="cangeneratedaterangereport" class="font-sans text-sm	hover:text-emerald-500"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/DateRangeReport">Date Wise  Report</router-link>
              <router-link v-if="cangenerateweeklyreport" to="/QuaterWeek"
                @click="() => { showMobileMenu = !showMobileMenu }"
                class=" font-sans text-sm	hover:text-emerald-500">Weekly Report</router-link>

              <router-link v-if="cangenerateMonthlyreport" to="/QuaterMonthly"
                @click="() => { showMobileMenu = !showMobileMenu }" class=" font-sans text-sm	hover:text-emerald-500">
                Monthly Report</router-link>

              <router-link v-if="cangenerateQuertelyreport" to="/QuaterlyReport"
                @click="() => { showMobileMenu = !showMobileMenu }"
                class=" font-sans text-sm	hover:text-emerald-500">Quarterly Report</router-link>

              <router-link v-if="cangenerateQuerterYearlyreport" to="/QuaterYearly"
                @click="() => { showMobileMenu = !showMobileMenu }"
                class=" font-sans text-sm	hover:text-emerald-500">Yearly Report</router-link>

              <router-link v-if="CanGenerateDisposalPerformanceReport"  class="font-sans text-sm	hover:text-emerald-500"
                @click="() => { showMobileMenu = !showMobileMenu }" to="/GenerateDisposalPerformanceReport">Disposal Performance Report</router-link>


            </div>
          </div>
          <li>
            <router-link v-if="canseesops" to="/viewSops" @click="() => {
            showMobileMenu = !showMobileMenu

          }
            "
              class="block py-2  font-sans text-lg	 px-3 text-regal-blue border-b
                 border-gray-100 hover:text-emerald-500	 md:hover:bg-transparent md:border-0  md:p-0 dark:text-blue-500  dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent "
              aria-current="page"> SOPs </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { useRouter } from 'vue-router'; // Import the useRouter function from vue-router
import { ref, onMounted, watch, computed } from 'vue';
import axiosInstance from "@/plugins/axios";
import Swal from 'sweetalert2';
import { useAuthService } from '@/store/Auth'; //  auth.js file

const router = useRouter();
const authStore = useAuthService();
const image = ref('');
const display_name = ref('');
const showMobileMenu = ref(false)
const isProfile = ref(false)
const userData = JSON.parse(localStorage.getItem('authService'));
const isCollection = ref(false)
const isAdmin = ref(false)

const permissions = ref([])
onMounted(() => {
  const authData = authStore.authData;
  image.value = authData.image;
  display_name.value = authData.display_name;
  permissions.value = authStore.authData.permissions || 0
  if (!Array.isArray(permissions.value) || permissions.value.length === 0) {
    localStorage.removeItem('token');
    localStorage.removeItem('authService');
    router.push({ name: 'Login' });
  }

});
const hasDashboardPermission = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view dashboard'));
const hasCollectionConsolePermission = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view collection console'));
const hasrolesetupview = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view roles setup'));
const hasviewstaff = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view shifts setup'));
const hasEnterdailyroasterPermission = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view daily roasters setup'));
const hasViewHospital = computed(() => Array.isArray(permissions.value) && permissions.value.some(permission => permission?.name === 'can view hospitals setup'));
const hasViewDisposalConsolePermission = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view disposal console'));
const hasViewShiftsSetupPermission = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view shifts setup'));
const hasViewcitysetup = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view cities setup'));
const hasViewTehsilsetup = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view tehsils setup'));
const hasViewusersetup = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can view users setup'));
const cangenerate24hoursreport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate 24 hours progress report'));
const cangeneratedaterangereport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate date range report'));
const cangenerateweeklyreport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate weekly report'));
const cangenerateMonthlyreport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate monthly report'));
const cangenerateQuertelyreport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate quarterly report'));
const cangenerateQuerterYearlyreport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate yearly report'));
const canseesops = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can see sop'));
const canseesetupsops = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can see sop setup'));
const cangenerateInfectiousWasteMonitoringReport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate infectious waste monitoring report'));
const CanGenerateDisposalPerformanceReport = computed(() => Array.isArray(permissions.value) && permissions?.value.some(permission => permission?.name === 'can generate disposal performance report'));

const profiledropdown = () => {
  isProfile.value = !isProfile.value
}

// Watch for changes in auth store data from the store
watch(
  () => authStore.authData,
  (newData) => {
    image.value = newData.image;
    display_name.value = newData.display_name;
  }
);

const handleLogin = async () => {
  try {
    const response = await axiosInstance.get('/is-user-login');
    // console.log(response.data);
    if (response?.data && response?.data?.data && response?.data?.data?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('authService');
      router.push({ name: 'Login' });
    }
  } catch (error) {
    console.log('Error Response:', error.response.status);
    if (error?.response?.status === 500) {
      // Handle the specific exception, for example, log it
      console.error('SessionExpireTimeMiddleware exception:', error?.response?.status);
      // Redirect to login or handle as needed
      localStorage.removeItem('token');
      localStorage.removeItem('authService');
      router && router.push({ name: 'Login' });
    }
    if (error?.response && error?.response && error?.response?.status !== 200) {
      localStorage.removeItem('token');
      localStorage.removeItem('authService');
      router.push({ name: 'Login' });
    }
  }
};

// eslint-disable-next-line no-unused-vars
const handleLogout = async () => {

  try {
    const response = await axiosInstance.post('/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('authService');
    router.push({ name: 'Login' }); // Redirect to the Login page after logout
  } catch (error) {

    localStorage.removeItem('token');
    localStorage.removeItem('authService');
    router.push({ name: 'Login' });
  }
}
onMounted(() => {
  authStore.handlepermission()

  handleLogin()
})
</script>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 190px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content2 {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 190px;
  right: 20px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content2 a {
  /* color: black; */
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content2 a:hover {
  background-color: #ddd;
}

.dropdown:hover .dropdown-content2 {
  display: block;
}

.dropdown-content3 {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 261px;
  /* right: 20px; */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content3 a {
  /* color: black; */
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content3 a:hover {
  background-color: #ddd;
}

.dropdown:hover .dropdown-content3 {
  display: block;
}

.dropdown-content a {
  /* color: black; */
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.dropdown:hover .dropdown-content {
  display: block;
}

/* .shadow:hover{
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5); transition: box-shadow 0.3s;
} */
.dropdown:hover .dropbtn:focus {
  color: #3e8e41;
}
</style>